module.exports = __webpack_public_path__ + "img/bodymeasurement.207bee42.svg";